export const TIMECLOCK = {
  navLink: 'admin-nav-jornada',
  rosterRow: 'jornada-roster-row',
  rosterStatusBadge: 'jornada-roster-status-badge',
  rosterLocationOutOfRangeBadge: 'jornada-roster-location-out-of-range-badge',
  manualCaptureButton: 'jornada-manual-capture-button',
  manualCaptureDialog: 'jornada-manual-capture-dialog',
  manualCaptureEventType: 'jornada-manual-capture-event-type',
  manualCaptureNote: 'jornada-manual-capture-note',
  manualCaptureSubmit: 'jornada-manual-capture-submit',
  exportButton: 'jornada-export-button',
  exportFormatSelect: 'jornada-export-format-select',
  exportStartInput: 'jornada-export-start-input',
  exportEndInput: 'jornada-export-end-input',
  kioskDeviceList: 'jornada-kiosk-device-list',
  kioskDeviceRow: 'jornada-kiosk-device-row',
  kioskCreateButton: 'jornada-kiosk-create-button',
  kioskCreateDialog: 'jornada-kiosk-create-dialog',
  kioskCreateLabel: 'jornada-kiosk-create-label',
  kioskCreateWorkCenter: 'jornada-kiosk-create-work-center',
  kioskCreateSubmit: 'jornada-kiosk-create-submit',
  kioskDeviceLink: 'jornada-kiosk-device-link',
  kioskDeviceDeactivate: 'jornada-kiosk-device-deactivate',
  weeklyReportSection: 'jornada-weekly-report-section',
  weeklyReportPrevWeek: 'jornada-weekly-report-prev-week',
  weeklyReportNextWeek: 'jornada-weekly-report-next-week',
  weeklyReportRange: 'jornada-weekly-report-range',
  weeklyReportRow: 'jornada-weekly-report-row',
  weeklyReportFormatSelect: 'jornada-weekly-report-format-select',
  weeklyReportExportButton: 'jornada-weekly-report-export-button',
  faltaNotificationsSection: 'jornada-falta-notifications-section',
  faltaNotificationRow: 'jornada-falta-notification-row',
  faltaNotificationConfirmButton: 'jornada-falta-notification-confirm-button',
  faltaNotificationDismissButton: 'jornada-falta-notification-dismiss-button',
};

export const JORNADA_TAB = {
  container: 'jornada-tab-container',
  dayRow: 'jornada-tab-day-row',
  correctButton: 'jornada-tab-correct-button',
  correctDialog: 'jornada-tab-correct-dialog',
  correctReason: 'jornada-tab-correct-reason',
  correctSubmit: 'jornada-tab-correct-submit',
  pinResetButton: 'jornada-tab-pin-reset-button',
  pinRevealValue: 'jornada-tab-pin-reveal-value',
  qrShowButton: 'jornada-tab-qr-show-button',
  qrRegenerateButton: 'jornada-tab-qr-regenerate-button',
  exportButton: 'jornada-tab-export-button',
};

export const KIOSK_PAGE = {
  pinInput: 'kiosk-pin-input',
  numpadButton: 'kiosk-numpad-button',
  identifyButton: 'kiosk-identify-button',
  clearButton: 'kiosk-clear-button',
  confirmPunchButton: 'kiosk-confirm-punch-button',
  cancelButton: 'kiosk-cancel-button',
  successMessage: 'kiosk-success-message',
  errorMessage: 'kiosk-error-message',
};

export const EMPLOYEE_TIMECLOCK = {
  navLink: 'employee-nav-jornada',
  punchCard: 'employee-home-punch-card',
  punchButton: 'employee-home-punch-button',
  dayRow: 'employee-jornada-day-row',
  exportButton: 'employee-jornada-export-button',
  locationBadgeOutOfRange: 'employee-home-location-out-of-range-badge',
  locationBadgeNoLocation: 'employee-home-location-no-location-badge',
};
